import Vue from 'vue'

// helper function
// this removes the "s." part from the search key
function removeSdot (obj) {
    let targetObj = JSON.parse(JSON.stringify(obj))

    for (var key in targetObj) {
       if (targetObj.hasOwnProperty(key)) {
            if(key.startsWith("s.")){
                targetObj[key.substr(2)] = targetObj[key]
                delete targetObj[key]
            }

       }
    }

    return targetObj

}

const state = {
    isCreatingInvoice: false,
    isDownloadingInvoiceResume: false,
    isDownloadingInvoiceResumeBulk: false,
    isCancelingInvoice: false,
    isPrintingInvoice: false,
    valueToAskMoreBillingInfo: 1000,
    defaultInvoiceSystemPreset: {
        invoiceSystemType: 1,
        isActive: false,
        primaveraGetArticlesURL: '',
        primaveraPostInvoiceURL: '',
        primaveraGetInvoiceCreditNoteURL: '',
        primaveraGetInvoiceDocumentURL: ''
    },
    selectedInvoice: null,
    invoicingIntegrationOptions:[
        {
            id: 0,
            name: 'None'
        },
        {
            id: 1,
            name: 'Primavera'
        }
    ],
    invoicingOptions:[
        {
            id: 0,
            label:"Automatically"
        },
        {
            id: 1,
            label:"Manually"
        }
    ],
    invoiceTargetTypes:[
        {
            id: 0,
            label: 'End customer'
        },
        {
            id: 1,
            label: 'Agent'
        },
    ],
    invoiceTypes:[
        {
            id: 0,
            label: 'Invoice'
        },
        {
            id: 1,
            label: 'Credit note'
        },
        {
            id: 10,
            label: 'Invoice and Bill'
        }
    ],
    selectedReservationInvoiceResume: {}
};

const getters = {
    getSelectedInvoice: (state) => state.selectedInvoice,
    getDefaultInvoiceSystemPreset: (state) => state.defaultInvoiceSystemPreset,
    getInvoicingIntegrationOptions: (state) => state.invoicingIntegrationOptions,
    getInvoicingOptions: (state) => state.invoicingOptions,
    getInvoiceTargetTypes: (state) => state.invoiceTargetTypes,
    getInvoiceTypes: (state) => state.invoiceTypes,
    getIsCancellingInvoice: (state) => state.isCancelingInvoice,
    getIsPrintingInvoice: (state) => state.isPrintingInvoice,
    getIsCreatingInvoice: (state) => state.isCreatingInvoice,
    getIsDownloadingInvoiceResume: (state) => state.isDownloadingInvoiceResume,
    getIsDownloadingInvoiceResumeBulk: (state) => state.isDownloadingInvoiceResumeBulk,
    getValueToAskMoreBillingInfo: (state) => state.valueToAskMoreBillingInfo,

};

const actions = {
    emitInvoice: ({state, commit, rootState}, payload) => {
        state.isCreatingInvoice = true

        // if the VAT is null we will show a popup asking the user to confirm if it is really to invoice to "Final Customer"
        // just a Yes/No propmpt, if user selects "Yes" we proceed, else we dont emit the invoice
        if(payload.client.vat == null || payload.client.vat == ""){
            return Vue.dialog.confirm('\
            <div class="fs-larg font-weight-600 mb-4">Missing Information</div>\
            <div>It seems that VAT number is missing. Please correct the information</div>', {
                customClass: 'cancelGreen okBlue cancelWide alignRight',
                reverse: true,
                okText: 'Invoice to End Customer',
                cancelText: 'OK'
            })
            .then(function () {
                return invoiceThis(payload)
            })
            .catch(function () {
                state.isCreatingInvoice = false
                return false
            });
        } else {
            return invoiceThis(payload)
        }


        function invoiceThis(payload) {

            return axios.post('/api/invoice/CreateInvoice', {
                supplierId: rootState.user.account.supplierId,
                bookingId: payload.reservationId,
                invoiceTargetType: payload.invoiceTargetType,
                isToInvoiceAndBill: payload.isToInvoiceAndBill,
                client: payload.client
            }).then(response => {
                state.isCreatingInvoice = false
                return response
            }).catch(err => {
                state.isCreatingInvoice = false
                return response
            })
        }


    },

    emitInvoiceBulk: ({state, rootState}, payload) => {
        console.log('emitInvoiceBulk', payload);
        state.isCreatingInvoice = true

        // set the correct "invoiceTargetType"
        let targetTypeId
        if(payload.invoiceTo == 'customer'){
            targetTypeId = 0
        } else {
            if(payload.selectedAgent && payload.selectedAgent.isOTA == true){
                targetTypeId = 2
            } else {
                targetTypeId = 1
            }
        }


        let dataToSend = {
            supplierId: rootState.user.account.supplierId,
            bookingSearchDepartureIn: rootState.reservations.reservationListType == 1? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchSalesIn: rootState.reservations.reservationListType == 3? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchTransfersIn: rootState.reservations.reservationListType == 2? removeSdot(rootState.reservations.reservationListFilters) : null,
            isToApplyAll: rootState.reservations.reservationListAllSelected,
            bookingList: rootState.reservations.bulkSelectedIds,
            isToManageInvoice: true,
            invoiceToForm: payload.invoiceToForm,
            invoiceTargetType: targetTypeId,
        }

        return axios.post('/api/invoice/createBulkInvoices', dataToSend).then(response => {
            state.isCreatingInvoice = false
            return response
        }).catch(err => {
            state.isCreatingInvoice = false
            return err
        })


    },

    setSelectedInvoice: ({commit}, payload) => {
        commit('SET_SELECTED_INVOICE', payload)
    },

    cancelInvoice: ({state, commit, rootState}, payload) => {
        state.isCancelingInvoice = true
        console.log('Calling cancelInvoice2', payload);
        return axios.get('/api/Invoice/CancelInvoice',{
                params: {
                supplierId: rootState.user.account.supplierId,
                // bookingId: payload.booking.id,
                bookingInvoiceId: payload.invoice.id,
            }
        }).then(response => {
            state.isCancelingInvoice = false
            return response

        }).catch(err => {
            state.isCancelingInvoice = false
            return err

        })
    },

    printInvoice: ({state, commit, rootState}, payload) => {
        Vue.toasted.info('Your print is being processed, may take a moment.');
        state.isPrintingInvoice = true
        return axios.get('/api/Invoice/GetSupplierInvoiceDocument',{
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingInvoiceId: payload
            }
        }).then(response => {
            state.isPrintingInvoice = false
            return response

        }).catch(err => {
            state.isPrintingInvoice = false
            return err

        })
    },

    downloadReservationInvoiceResume: ({state, commit, rootState}, payload) => {
        state.isDownloadingInvoiceResume = true
        return axios.get('/api/invoice/GetSupplierInvoiceResume', {
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingId: payload
            }
        }).then(response => {
            state.isDownloadingInvoiceResume = false

            if(response.status == 200){
                commit('SET_RESERVATION_INVOICE_RESUME', response.data)
            }

            return response
        }).then(err => {
            state.isDownloadingInvoiceResume = false
            return err
        })
    },

    downloadReservationInvoiceResumeBulk: ({state, commit, rootState}, payload) => {
        state.isDownloadingInvoiceResumeBulk = true

        let dataToSend = {
            supplierId: rootState.user.account.supplierId,
            bookingSearchDepartureIn: rootState.reservations.reservationListType == 1? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchSalesIn: rootState.reservations.reservationListType == 3? removeSdot(rootState.reservations.reservationListFilters) : null,
            bookingSearchTransfersIn: rootState.reservations.reservationListType == 2? removeSdot(rootState.reservations.reservationListFilters) : null,
            isToApplyAll: rootState.reservations.reservationListAllSelected,
            bookingList: rootState.reservations.bulkSelectedIds,
            isToManageInvoice: true,
            invoiceToForm: payload.invoiceToForm,
            invoiceTargetType: payload.invoiceTo == 'agent'? 1 : 0,
        }

        return axios.post('/api/invoice/executeBulkInvoicesCalculations', dataToSend).then(response => {
            state.isDownloadingInvoiceResumeBulk = false

            if(response.status == 200){
                commit('SET_RESERVATION_INVOICE_RESUME', response.data)
            }

            return response
        }).then(err => {
            state.isDownloadingInvoiceResumeBulk = false
            return err
        })
    },

    getBookingsFromInvoice: ({state, rootState}, payload) => {
        return axios.get('/api/Invoice/GetSupplierBookingsByInvoice', {
            params: {
                supplierId: rootState.user.account.supplierId,
                bookingInvoiceId: payload.bookingInvoiceId
            }
        }).then(response => {
            if(response.status == 200){
                return response.data
            }
            return response
        }).catch(err => {
            return err
        })
    }

};

const mutations = {
    SET_SELECTED_INVOICE: (state, payload) => {
        state.selectedInvoice = payload
    },

    SET_RESERVATION_INVOICE_RESUME: (state, payload) => {
        state.selectedReservationInvoiceResume = payload
    }

};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js